import React, { useEffect, useState } from 'react';

import { Link, useHistory, useLocation } from 'react-router-dom';

import { BiPlus, BiSearch } from 'react-icons/bi';
import { CgPlayList } from 'react-icons/cg';
import { FaMotorcycle } from 'react-icons/fa';
import { MdStoreMallDirectory } from 'react-icons/md';
import { SiIfood } from 'react-icons/si';

import Input from '../../../newComponents/Input';
import Load from '../../../newComponents/Load';
import ModalFilter from '../ModalFilter';
import Pagination from '../LoadMore';

import * as S from './styles';

import { useMonitor } from '../../../hooks/newMonitor';
import {
  foundEstagio,
  foundEstagioIfood,
} from '../../../utils/estagiosPedidos';
import { distanceBetweenDatesInFull } from '../../../utils/DistanceBetweenDatesInFull';

interface PanelContainerProps {
  selectedOrderId: number | string | null;
  setSelectedOrderId: React.Dispatch<
    React.SetStateAction<number | string | null>
  >;
}

const PanelContainer: React.FC<PanelContainerProps> = (props) => {
  const { selectedOrderId, setSelectedOrderId } = props;

  const history = useHistory();
  const { search } = useLocation();

  const query = new URLSearchParams(search);
  const orderId = query.get('orderId');

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { isLoading, listOrders, filter, setFilter, emAguardo } = useMonitor();

  const handleMainIsOpen = (pedidoId: number | string): void => {
    history.push('/monitor_pedidos');
    setSelectedOrderId(pedidoId);
  };

  const handleTextFilter = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.persist();
    setFilter((oldState) => ({ ...oldState, text: e.target.value || '' }));
  };

  const handleInsternshipFilter = (insternship: number): void => {
    if (!filter.insternship.includes(0)) {
      setFilter((oldState) => ({
        ...oldState,
        insternship: [insternship],
      }));
    }
  };

  const handleArrInsternshipsFilter = (insternships: number[]): void => {
    if (filter.insternship.includes(0)) {
      setFilter((oldState) => ({
        ...oldState,
        insternship: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      }));
    }
  };

  const getCompletedHours = (string: string): string => {
    const newDate = new Date(string);

    return `${(newDate.getHours() < 10 ? '0' : '') + newDate.getHours()}:${
      (newDate.getMinutes() < 10 ? '0' : '') + newDate.getMinutes()
    }`;
  };

  useEffect(() => {
    if (orderId) {
      setFilter((oldState) => ({
        ...oldState,
        insternship: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  return (
    <S.Container selectedOrderId={selectedOrderId}>
      <div className="header">
        <div className="header__title">
          <h1>Pedidos</h1>
          <div>
            {listOrders && <span>{listOrders.orders?.length || 0}</span>}
          </div>
        </div>

        <div className="header__filter">
          <Input
            icon={BiSearch}
            placeholder="Buscar pelo nome"
            value={filter.text}
            onChange={handleTextFilter}
          />

          <div
            className="header__filter__button"
            onClick={() => setModalIsOpen(true)}
          >
            <CgPlayList size={32} />
          </div>
        </div>

        <Link className="new__order" to="/monitor_pedidos/new">
          <BiPlus size={22} style={{ marginRight: 5 }} />
          <p>Novo Pedido</p>
        </Link>

        <div className="header__filter__fast">
          <div
            className={`${
              filter.insternship.some((n) => n === 0) && 'emphasis'
            }`}
            onClick={() => handleInsternshipFilter(0)}
          >
            <p>Aguardando</p>
            {emAguardo && <S.Blob />}
          </div>

          <div
            className={`${
              filter.insternship.every((el) =>
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].includes(el),
              ) && 'emphasis'
            }`}
            onClick={() => {
              handleArrInsternshipsFilter([
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
              ]);
            }}
          >
            <p>Aceito</p>
          </div>
        </div>
      </div>

      <S.Divider />

      {!listOrders || isLoading ? (
        <div
          style={{
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Load />
        </div>
      ) : (
        <div className="body">
          {listOrders?.orders.map((pedido, index, array) => {
            if (pedido.ifoodOrder) {
              return (
                <React.Fragment key={pedido.ifoodOrder._id}>
                  <S.PedidoItem
                    color={foundEstagioIfood(pedido.ifoodOrder.status).color}
                    onClick={() => {
                      if (pedido.ifoodOrder) {
                        handleMainIsOpen(pedido.ifoodOrder._id);
                      }
                    }}
                  >
                    <div className="etiquetas">
                      <div>
                        <p>#{pedido.ifoodOrder.displayId}</p>
                      </div>
                      <div className="etiquetas__estagio">
                        <p>
                          {foundEstagioIfood(pedido.ifoodOrder.status).texto}
                        </p>
                      </div>
                      {pedido.ifoodOrder.orderTiming === 'SCHEDULED' && (
                        <div className="etiquetas__agendado">
                          <p>Agendado</p>
                        </div>
                      )}
                      <SiIfood size={24} color="#ea1d2c" />
                    </div>

                    <div className="information">
                      {pedido.ifoodOrder.orderType === 'DELIVERY' ? (
                        <div className="information__icon delivery">
                          <FaMotorcycle size={24} color="#FF2190" />
                        </div>
                      ) : (
                        <div className="information__icon withdrawal">
                          <MdStoreMallDirectory size={24} color="#FF8946" />
                        </div>
                      )}
                      <div className="information__text">
                        <h2>{pedido.ifoodOrder.customer.name}</h2>
                        <p>
                          {`Feito ${distanceBetweenDatesInFull(
                            pedido.ifoodOrder.createdAt,
                          )}, às ${getCompletedHours(
                            pedido.ifoodOrder.createdAt,
                          )}`}
                        </p>
                      </div>
                    </div>
                  </S.PedidoItem>
                  {index < array.length - 1 && <S.Divider />}
                </React.Fragment>
              );
            }
            return (
              <React.Fragment key={pedido.id}>
                <S.PedidoItem
                  color={foundEstagio(pedido.status as any).color}
                  onClick={() => handleMainIsOpen(pedido.id)}
                >
                  <div className="etiquetas">
                    <div>
                      <p>#{pedido.id}</p>
                    </div>
                    <div className="etiquetas__estagio">
                      <p>{foundEstagio(pedido.status as any).texto}</p>
                    </div>
                    {pedido.scheduledDeliveryAt && (
                      <div className="etiquetas__agendado">
                        <p>Agendado</p>
                      </div>
                    )}
                  </div>

                  <div className="information">
                    {pedido.deliveryAddressId ? (
                      <div className="information__icon delivery">
                        <FaMotorcycle size={24} color="#FF2190" />
                      </div>
                    ) : (
                      <div className="information__icon withdrawal">
                        <MdStoreMallDirectory size={24} color="#FF8946" />
                      </div>
                    )}
                    <div className="information__text">
                      <h2>{pedido?.customer?.tradingName ?? 'Venda balcão'}</h2>
                      <p>
                        {`Feito ${distanceBetweenDatesInFull(
                          pedido.createdAt,
                        )}, às ${getCompletedHours(pedido.createdAt)}`}
                      </p>
                    </div>
                  </div>
                </S.PedidoItem>
                {index < array.length - 1 && <S.Divider />}
              </React.Fragment>
            );
          })}
        </div>
      )}

      <Pagination />

      <S.Divider />

      <div className="footer">
        <div className="footer__quantity">
          <p>Quantidade:</p>
          <span>
            {`${listOrders?.orders?.length || 0} ${
              listOrders?.orders && listOrders.orders.length > 1
                ? 'pedidos'
                : 'pedido'
            }`}
          </span>
        </div>

        <div className="footer_total">
          <p>Total:</p>
          <span>
            {(
              listOrders?.orders?.reduce((acc, cur) => {
                if (cur.ifoodOrder) {
                  return acc + Number(cur.ifoodOrder.total.orderAmount);
                }
                return acc + Number(cur.total);
              }, 0) || 0
            ).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </span>
        </div>
      </div>

      {modalIsOpen && (
        <ModalFilter
          setModalIsOpen={setModalIsOpen}
          filter={filter.insternship}
          handleInsternshipFilter={() => {
            // handleInsternshipFilter
          }}
        />
      )}
    </S.Container>
  );
};

export default PanelContainer;
